//@ts-nocheck
import React, { useState, useContext, useEffect } from "react";
import { Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { LoaderContext, getContext } from "../../../Helpers/Context/Context";
import Modal from "react-modal";
import InputForm, {
  AutoCompleteValue,
} from "../../../Components/InputForm/InputForm";
import { ExcelRenderer } from "react-excel-renderer";
import axios from "axios";
import moment from "moment";
import fileDownload from "js-file-download";
import {
  getUnitCodeDashboardData,
  CommonDropdownData,
  getUnitCodeExportToExcel,
  uploadBulkUnitCodeDetails,
  unitcodeSampleFileExportToExcel,
} from "../../../Helpers/APIEndPoints/EndPoints";
import { APICall } from "../../../Helpers/Network/APICalls";
import DynamicGrid from "../../../Components/DynamicGrid/DynamicGrid";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import { Collapse } from "react-bootstrap";
import notify, { ToastType } from "../../../Helpers/ToastNotification";
import ButtonComponent from "../../../Components/ButtonForm/Button";
import MyPDF from "../path/to/file.pdf";
import "./UnitCodeMaster.css";
import { fetchAuthToken } from "../../../Helpers/Network/OAuthHandler";
import { ApiStatus } from "../../../Helpers/Enums/ApiStatus";

Modal.setAppElement("#root"); // Use the selector for your root element

const UnitCodeMaster = () => {
  let navigate = useNavigate();
  const context = getContext();
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [searchText, setSearchText] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [count, setCount] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [companyOptions, setCompanyOptions] = useState([]);
  const [company, setCompany] = useState<any>();
  const [dashboardFilterOn, setDashboardFilterOn] = useState(false);
  const [errorMessage, setErrorMessage] = useState([]);
  const [dashboardData, setDashboardData] = useState([]);

  const [formErrors, setFormErrors] = useState({});
  let formErrorObj = {};
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalIsOpenError, setModalIsOpenError] = useState(false);

  const [bulkUploadRequestExcelFileName, setBulkUploadRequestExcelFileName] =
    useState("No File Uploaded");
  const [selectedFile, setSelectedFile] = useState(null);

  const selectOnChange = (event: any, apiFieldName: any) => {
    if (apiFieldName === "Company") {
      setCompany(event);
    }
  };

  useEffect(() => {
    getDropDownDataApiCall();
  }, []);

  const getDropDownDataApiCall = async () => {
    showLoader();
    let requestParams = {
      dropdownName: "companydd",
    };
    const res = await APICall(CommonDropdownData, requestParams);

    if (res.Status === ApiStatus.OK && res.Data.length > 0) {
      let options = await res.Data;
      await setCompanyOptions(options);
    } else {
      await setCompanyOptions([]);
      //notify(ToastType.Error, res.Message);
    }
    hideLoader();
  };

  const onClickFunction = async (event: any, action: any) => {
    if (action === "Apply") {
      let isEmptyReqObj = false;
      if (dashboardFilterOn === true) {
        let reqFilterObj = {
          company:
            company && company.length > 0
              ? company.map(({ value }) => value).toString()
              : "",
        };
        isEmptyReqObj = Object.values(reqFilterObj).every((f) => {
          if (f === "" || f === null || f === undefined) {
            return true;
          } else {
            return false;
          }
        });
      }

      if (isEmptyReqObj === true) {
        notify(ToastType.Error, "Select at least one filter.");
      } else {
        await getDashboardData("");
      }
    } else if (action === "Reset") {
      await resetFunction();
    }
  };

  const resetFunction = async () => {
    setCompany(null);
    await getDashboardData("reset");
  };

  const exportToExcelFunction = async () => {
    const params = {
      start: start,
      resultsPerPage: pageSize,
      searchText: searchText,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
      CompanyId:
        company && company.length > 0
          ? company.map(({ value }) => value).toString()
          : "",
    };

    let token = await fetchAuthToken();

    axios
      .request({
        responseType: "blob",
        method: "POST",
        url: getUnitCodeExportToExcel,
        data: params,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
      
        fileDownload(
          response.data,
          `UnitCode_` +
            `${moment(new Date()).format(moment.HTML5_FMT.DATE)}` +
            `.xlsx`
        );
      })
      .catch((error) => {
       
        notify(ToastType.Error, "Failed to export data.");
      });
  };

  const openModalError = () => {
    setModalIsOpenError(true);
  };
  const closeModalError = () => {
    setModalIsOpenError(false);
    clearFunction();
  };

  useEffect(() => {
    getDashboardData("");
  }, [start, sortColumn, sortDirection, searchText, count]);

  const getDashboardData = async (btn: any) => {
    showLoader();
    let obj = {
      start: start,
      resultsPerPage: pageSize,
      searchText: searchText,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
      CompanyId:
        company && company.length > 0
          ? company.map(({ value }) => value).toString()
          : "",
    };
    if (btn === "reset") {
      obj = {
        start: start,
        resultsPerPage: pageSize,
        searchText: searchText,
        sortColumn: sortColumn,
        sortDirection: sortDirection,
        CompanyId: "",
      };
    }
    const resp = await APICall(getUnitCodeDashboardData, obj);

    if (resp?.Data?.Data?.length > 0) {
      setDashboardData(resp?.Data?.Data);
    } else {
      setDashboardData([]);
    }

    setCount(resp?.Data?.Data[0]?.TotalCount || resp?.Data?.Data?.length || 0);
    hideLoader();
  };

  const openModal = () => {
    setModalIsOpen(true);
    clearFunction();
  };

  const closeModal = () => {
    setModalIsOpen(false);
    clearFunction();
  };

  const onUploadValidationCheck = () => {
    setFormErrors({});
    formErrorObj = {};
    if (
      !bulkUploadRequestExcelFileName ||
      bulkUploadRequestExcelFileName === "" ||
      bulkUploadRequestExcelFileName === "No File Uploaded"
    ) {
      formErrorObj["bulkUpload_isEmpty"] = "Please upload file.";
      setFormErrors(formErrorObj);
    }
  };

  const handleUpload = async () => {
    await onUploadValidationCheck();
    let isEmpty = Object.values(formErrorObj).every((f) => {
      return f === "" || f === null || f === undefined;
    });
    let fileInBase64 = "";
    if (isEmpty === true) {
      const formData = new FormData();
      // 'file' should match your backend's file input name
      formData.append("file", selectedFile);
      formData.append("ImportExcelUserId", context?.Id);

      const data = await APICall(
        uploadBulkUnitCodeDetails,
        formData,
        "POST",
        false,
        "",
        true
      );

      if (data.Message == "Ok") {
        // Close the modal after the upload is complete (or handle errors appropriately).
        closeModal();
        clearFunction();
        notify(ToastType.Success, data?.Data);
        getDashboardData(""); // Success message
      } else if (
        data.Message == "VALIDATION_ERROR" ||
        data.Message == "error"
      ) {
        // notify(ToastType.Error, Message);
        openModalError();
        setErrorMessage(data);
      } else if (data.Message == "Fail") {
        notify(ToastType.Error, data.Data?.Data?.Message || data?.Data?.Data);
      } else {
        // ) {
        //   let errorMessages = data?.Data;
        //   let Message = "";
        //   for (let i = 0; i < errorMessages.length; i++) {
        //     Message += i + 1 + ". " + errorMessages[i] + `\n`;
        //   }
        //   notify(ToastType.Error, Message);
        // } else {
        notify(ToastType.Error, JSON.stringify(data?.Data));
      }
    }
  };

  const bulkUploadRequestExcelFileChange = (param: any) => {
    let bulkUploadRequestExcelFile = param.target.files[0];
    if (param.target.files.length > 0) {
      if (
        bulkUploadRequestExcelFile.size &&
        bulkUploadRequestExcelFile.size <= 31457280
      ) {
        let fileExtLength = bulkUploadRequestExcelFile.name.split(".");
        if (fileExtLength.length === 2) {
          let fileExtensionName = bulkUploadRequestExcelFile.name
            .split(".")[1]
            .toLowerCase();
          if (fileExtensionName === "xlsx") {
            formErrorObj = {};
            setFormErrors({});

            setBulkUploadRequestExcelFileName(bulkUploadRequestExcelFile.name);
            ExcelRenderer(bulkUploadRequestExcelFile, async (err, resp) => {
              if (err) {
                clearFunction();
                notify(ToastType.Error, err);
              } else {
                if (
                  resp.rows[0][0] != "Unit Name" &&
                  resp.rows[0][1] != "Old Unit Code" &&
                  resp.rows[0][2] != "Payroll Area" &&
                  resp.rows[0][3] != "Company Code" &&
                  resp.rows[0][4] != "IsActive"
                ) {
                  clearFunction();
                  notify(
                    1,
                    "Invalid excel file, Please refer sample excel format."
                  );
                } else {
                  setSelectedFile(bulkUploadRequestExcelFile);
                  // await htmlEncodeAllFields(resp.rows);
                }
              }
            });
          } else {
            clearFunction();
            notify(ToastType.Error, "You should uplaod excel file only.");
          }
        } else {
          clearFunction();
          notify(
            1,
            "You should upload valid excel file only, file name contains multiple extensions."
          );
        }
      } else {
        clearFunction();
        notify(ToastType.Error, "File size should not be greater than 30 MB.");
      }
    } else {
      clearFunction();
      notify(ToastType.Error, "Invalid file selected");
    }
  };

  const clearFunction = () => {
    setFormErrors({});
    formErrorObj = {};
    setBulkUploadRequestExcelFileName("No File Uploaded");
    setSelectedFile(null);
  };

  const Options = {
    showEmptyDataSourceMessage: true,
    selectableRows: "none",
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    responsive: "standard",
    onChangeRowsPerPage: () => {},
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
      } else {
        setSearchText("");
      }
      setStart(0);
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      setStart(0);
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
  };
  const GridColumns = [
    {
      name: "Id",
      label: "Id",
      options: {
        display: false,
      },
    },
    {
      name: "Name",
      label: "Unit Name",
      options: {
        display: true,
        filter: true,
        sort: true,
      },
    },
    {
      name: "OldUnitCode",
      label: "Old Unit Code",
      options: {
        display: true,
        filter: true,
        sort: true,
      },
    },
    {
      name: "Code",
      label: "Payroll Area",
      options: {
        display: true,
        filter: true,
        sort: true,
      },
    },
    {
      name: "Company",
      label: "Company",
      options: {
        display: true,
        filter: true,
        sort: true,
      },
    },
    {
      name: "IsActive",
      label: "Active Status",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
        setCellHeaderProps: () => ({
          style: { textAlign: "center" },
        }),
        customBodyRender: (value: any, tableMeta: any) => {
          if (value) {
            return <i className="fas fa-check"></i>;
          } else {
            return <i className="fas fa-times"></i>;
          }
        },
      },
    },
    {
      name: "",
      label: "Action",
      options: {
        display: true,
        filter: false,
        sort: false,
        customBodyRender: (value: any, tableMeta: any) => {
          let id = tableMeta.rowData[0];
          const IsFromSFData =
            tableMeta.tableData[tableMeta.rowIndex].IsFromSFData;
          if (IsFromSFData) return null;
          return (
            <Tooltip title="edit">
              <p className="ml-3">
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("edit", {
                      state: { id },
                    });
                  }}
                >
                  <i className="fas fa-edit"></i>
                </a>
              </p>
            </Tooltip>
          );
        },
      },
    },
  ];

  const downloadSampleExcel = async () => {
    let token = await fetchAuthToken();
    axios
      .request({
        responseType: "blob",
        method: "POST",
        url: unitcodeSampleFileExportToExcel,
        data: {},
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
      
        fileDownload(response.data, `Sample_UnitCode.xlsx`);
      })
      .catch((error) => {
      
        notify(ToastType.Error, "Failed to export data.");
      });
  };

  return (
    <>
      <div className="form-main">
        <div className="page-title w-100">
          <div className="col-lg-12 p-0">
            <div className="row justify-content-end">
              <div className="col-xl-5 col-lg-7 col-md-8 SearchBoxUnitCode">
                <div className="row d-flex ser_flx">
                  <div className="col-lg-6 col-md-6 serc_left p-0 searchInput mr-2">
                    <InputForm
                      value={searchText}
                      placeholder={"Search"}
                      isDisabled={false}
                      textArea={false}
                      onChange={(e) => {
                        setSearchText(e.target.value);
                      }}
                    />
                    <i className="fa fa-search ml-2" aria-hidden="true"></i>
                  </div>

                  <div
                    className="float-right d-flex col-lg-6 col-md-6 justify-content-end"
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <Tooltip title="import to excel">
                      <button className="btn btn-submit" onClick={openModal}>
                        <i className="fa fa-upload"></i>
                      </button>
                    </Tooltip>

                    <Tooltip
                      title="Export to excel"
                      style={{ marginLeft: "5px", cursor: "pointer" }}
                    >
                      <button
                        className="btn btn-submit"
                        onClick={() => {
                          if (dashboardData.length === 0) {
                            notify(ToastType.Error, "No data available");
                          } else {
                            exportToExcelFunction();
                          }
                        }}
                      >
                        <i className="fa fa-download"></i>
                      </button>
                    </Tooltip>

                    <ButtonComponent
                      className="btn btn-submit"
                      style={{
                        marginLeft: 5,
                        cursor: "pointer",
                      }}
                      icon={"fas fa-plus-circle"}
                      value={"Create"}
                      onClick={() => {
                        navigate("edit", {
                          state: {
                            id: 0,
                          },
                        });
                      }}
                    />
                    <ul
                      className="float-right filter-icon "
                      style={{ position: "relative" }}
                    >
                      <li
                        onClick={() =>
                          setDashboardFilterOn((current) => !current)
                        }
                        className="filter-btn"
                      >
                        <a className="filter-btn">
                          <i className="fa fa-filter"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="page-content row filter-row-container mb-0 ml-0 mr-0">
        <div className="col-lg-12 p-0">
          <div className="row">
            <div className="col-lg-4 col-md-4"></div>
            <div className="col-lg-4 col-md-2"></div>
            <div className="col-lg-4 col-md-6">
              <div className="row d-flex justify-content-end mr-xl-2 mr-md-2">
                <div className="col-lg-12 mt-1 p-0 searchInput">
                  <InputForm
                    value={searchText}
                    placeholder={"Search"}
                    isDisabled={false}
                    textArea={false}
                    onChange={(e) => {
                      setSearchText(e.target.value);
                    }}
                  />
                  <i className="fa fa-search ml-2" aria-hidden="true"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <div>
        <div className="clearfix"></div>
        <Collapse in={dashboardFilterOn}>
          <div className="filter-content ">
            <div className="row">
              <div className="col-lg-3 col-md-3 col-xs-12 mb-2">
                <div className="form-group">
                  <label className="col-form-label">Company</label>
                  <SelectForm
                    options={companyOptions}
                    placeholder="Select Company"
                    isDisabled={false}
                    value={company}
                    onChange={(event: any) => selectOnChange(event, "Company")}
                    isMulti={true}
                    noIndicator={false}
                    noSeparator={false}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div
                className="col-lg-12 col-md-12"
                style={{ marginBottom: "25px" }}
              >
                <div className="float-right">
                  <button
                    className="btn btn-cancel"
                    style={{ marginLeft: 5 }}
                    onClick={(e) => onClickFunction(e, "Reset")}
                  >
                    <i className="fas fa-undo"></i> Reset
                  </button>
                  <button
                    className="btn btn-submit"
                    style={{ marginLeft: 5 }}
                    onClick={(e) => onClickFunction(e, "Apply")}
                  >
                   <i className="fas fa-check"></i> Apply
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Collapse>

        <DynamicGrid
          options={Options}
          data={dashboardData}
          columns={GridColumns}
        />
      </div>

      <div className="ModalSize">
        <Modal
          ariaHideApp={false}
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          contentLabel="File Upload Modal"
          style={{
            content: {
              width: "30%", // Adjust this value as needed
              height: "16em", // Adjust this value as needed
              margin: "auto", // Center the modal horizontally
            },
          }}
        >
          <div className="alignment">
            <div className="col-lg-12 p-0">
              <div
                className="row"
                style={{ marginRight: "5px", float: "right" }}
              >
                {/* <a
                  href={require("../../../Assets/SampleFile/UnitCode_Sample.xlsx")}
                  target="_blank"
                  className="btn btn-cancel"
                  download="UnitCode_Sample.xlsx"
                >
                  <i className="fa fa-download"></i> Sample File
                </a> */}

                <a
                  onClick={downloadSampleExcel}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-cancel"
                >
                  <i className="fa fa-download"></i> Sample File
                </a>
              </div>
            </div>
            <div className="col-lg-12 p-0">
              <div className="row">
                <div
                  className="col-lg-12 col-md-12"
                  style={{ marginBottom: "15px" }}
                >
                  <div className="form-group"></div>
                  <label>Import Excel</label>
                  <sup style={{ fontSize: "13px" }}>*</sup>
                  <input
                    autoComplete={AutoCompleteValue}
                    onChange={bulkUploadRequestExcelFileChange}
                    accept=".xlsx"
                    className="form-control"
                    type="file"
                  />
                  <p style={{ color: "red" }}>
                    {formErrors["bulkUpload_isEmpty"]}
                  </p>
                </div>
                <div className="col-lg-12 col-md-12">
                  <button className="btn btn-submit" onClick={handleUpload}>
                    Upload
                  </button>
                  <button
                    className="btn btn-cancel"
                    onClick={closeModal}
                    style={{ marginLeft: "10px" }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>

      <div className="ModalSize">
        <Modal
          ariaHideApp={false}
          isOpen={modalIsOpenError}
          onRequestClose={closeModalError}
          contentLabel="Error Message"
          style={{
            content: {
              width: "30%", // Adjust this value as needed
              height: "16em", // Adjust this value as needed
              margin: "auto", // Center the modal horizontally
              backgroundColor: "antiquewhite",
            },
          }}
        >
          <div className="col-lg-12 p-0">
            <div className="row">
              <div
                className="col-lg-12 col-md-12"
                style={{ marginBottom: "15px" }}
              >
                {errorMessage?.Data?.map((errorMag: any, index: any) => (
                  <p key={index} className="ErrorMessage">
                    {index + 1}. {errorMag}
                  </p>
                ))}
              </div>
              <div className="col-lg-12 col-md-12">
                <button
                  className="btn btn-cancel"
                  onClick={closeModalError}
                  style={{ marginLeft: "10px", float: "right" }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default UnitCodeMaster;
